export default __webpack_public_path__ + "static/image6-30372afcabab85a16ae11ec0c61d524d.jpg";